import { Directive, ElementRef, inject, Input, OnInit } from '@angular/core';
import { UiTourService } from '../services/ui-tour.service';

@Directive({ selector: '[appUiTour]' })
export class UiTourDirective implements OnInit {
  public readonly uiTour: UiTourService = inject(UiTourService);
  public readonly element: ElementRef = inject(ElementRef);

  @Input() public appUiTour: string = '';

  public ngOnInit(): void {
    this.uiTour.registerStepElement(
      this.appUiTour ?? this.element.nativeElement.id,
      this
    );
  }
}
